/** @format */

import { SnackbarProvider } from "notistack";
import React from "react";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import "./App.css";
import { persistor, store } from "./Redux/Store/Store";
import routes from "./routes/routes";
import ThemeProvider from "./theme/ThemeProvider";

const router = createBrowserRouter(routes);
const App = () => {
  return (
    <SnackbarProvider maxSnack={1}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ThemeProvider>
            <RouterProvider router={router} />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </SnackbarProvider>
  );
};

export default App;
